import React, { useState } from 'react';
import { MODULES } from '../constants';

export const Compare: React.FC = () => {
  const [filter, setFilter] = useState('');

  return (
    <div className="max-w-6xl mx-auto p-6">
      <h2 className="text-3xl font-bold mb-6 text-cyber-dark">Compare Threats</h2>
      
      <div className="overflow-x-auto bg-white rounded-xl shadow-lg">
        <table className="w-full text-left border-collapse">
          <thead>
            <tr className="bg-slate-100 border-b-2 border-slate-200">
              <th className="p-4 font-bold text-slate-700">Type</th>
              <th className="p-4 font-bold text-slate-700">Self-Replicating?</th>
              <th className="p-4 font-bold text-slate-700">Main Goal</th>
              <th className="p-4 font-bold text-slate-700">Common Entry</th>
            </tr>
          </thead>
          <tbody>
            {MODULES.map((m, i) => (
              <tr key={m.id} className={i % 2 === 0 ? 'bg-white' : 'bg-slate-50'}>
                <td className="p-4 font-bold text-cyber-accent">{m.title}</td>
                <td className="p-4">
                  {m.id.includes('worm') || m.id.includes('botnet') ? 
                    <span className="text-red-600 font-bold">Yes</span> : 
                    <span className="text-slate-500">No (User action needed)</span>}
                </td>
                <td className="p-4 text-sm">{m.objectives}</td>
                <td className="p-4 text-sm">{m.entryVectors.substring(0, 60)}...</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      
      <div className="mt-8 bg-blue-50 p-6 rounded-xl border border-blue-200">
        <h3 className="font-bold text-lg mb-2">Quick Comparison Tip</h3>
        <p>
          <strong>Virus vs. Worm:</strong> A virus needs a host file (like a parasite). A worm is a standalone program that travels the network.
        </p>
      </div>
    </div>
  );
};
